// The widget registry: type → component. The interpreter renders any schema using only this map.
import { createElement, lazy, Suspense, type ComponentType } from 'react';
import type { RegistryEntry, WidgetComponentProps } from './types';
import { WIDGET_SCHEMAS } from './schemas';
import { metricCard } from './widgets/MetricCard';
import { lineChart } from './widgets/LineChart';
import { barChart } from './widgets/BarChart';
import { dataTable } from './widgets/DataTable';
import { liveFeed } from './widgets/LiveFeed';
import { funnel } from './widgets/Funnel';
import { heatmap } from './widgets/Heatmap';
import { syncPanel } from './widgets/SyncPanel';
import { dataStatus } from './widgets/DataStatus';
import { alertList } from './widgets/AlertList';
import { crudTable } from './widgets/CrudTable';
import { wizard } from './widgets/Wizard';
import { currencyTable } from './widgets/CurrencyTable';

/** Heavy, single-page widgets load on demand so the first paint (especially on phones) stays small. */
function deferred(load: () => Promise<{ default: ComponentType<WidgetComponentProps> }>): RegistryEntry {
  const C = lazy(load);
  return { component: (props) => createElement(Suspense, { fallback: createElement('div', { className: 'skeleton', style: { flex: 1, minHeight: 120 } }) }, createElement(C, props)) };
}
const builder = deferred(() => import('./widgets/Builder').then((m) => ({ default: m.builder.component })));
const aiAssistant = deferred(() => import('./widgets/AiAssistant').then((m) => ({ default: m.aiAssistant.component })));

export const REGISTRY: Record<keyof typeof WIDGET_SCHEMAS, RegistryEntry> = {
  'metric-card': metricCard,
  'line-chart': lineChart,
  'bar-chart': barChart,
  'data-table': dataTable,
  'live-feed': liveFeed,
  funnel,
  heatmap,
  'sync-panel': syncPanel,
  'data-status': dataStatus,
  'alert-list': alertList,
  'crud-table': crudTable,
  wizard,
  builder,
  'currency-table': currencyTable,
  'ai-assistant': aiAssistant,
};
